<template>
  <div id="landscapingHero" class="hero">
    <div
      class="heroContentContainer d-flex flex-column justify-content-center align-items-center"
    >
      <img
        :src="$webDomain + '/' + subImageType + '/' + subImage"
        class="background-image"
        alt="Hero Image"
      />
      <div class="hero-title-container">
        <h1 class="hero-title" v-if="$i18n.locale === 'CH'">
          {{ data.companyNameCh }}
        </h1>
        <h1 class="hero-title" v-if="$i18n.locale === 'EN'">
          {{ data.companyNameEn }}
        </h1>
      </div>
      <div class="hero-content-container">
        <p class="hero-content">
          {{ $t("homePage.hero.subtitle") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Hero",
  data() {
    return {
      data: "",
      subImage: "",
      subImageType: "",
    };
  },
  created() {
    axios.get(this.$webDomain + "/gardenInit/GardenBasic").then((response) => {
      this.data = response.data.data[0];
      this.subImage = response.data.data[0].topImageList[0].subImage;
      this.subImageType = response.data.data[0].topImageList[0].subImageType;
    });
  },
};
</script>

<style scoped>
.heroContentContainer {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.background-image {
  position: fixed;
  z-index: -1;
  top: 0;
  height: 100vh;
  width: 100vw;
  object-fit: cover;
}
</style>
